// extracted by mini-css-extract-plugin
module.exports = {"checkoutFooter":"az_Ik","footerBox":"az_Jk","copyright":"az_Kk","digicert":"az_Lk"};